import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  dialog: {
    position: 'absolute',
    width: '504px',
    height: '294px',
  },
  button: {
    width: '100px',
    borderRadius: '24px',
    height: '40px',
    textTransform: 'none',
    marginBottom: '15px',
  },
  dialogTitle: {
    textAlign: 'center',
  },
  dialogContent: {
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '20px',
    overflow: 'hidden',
  },
  dialogAction: {
    justifyContent: 'center',
  },
  titleIconSuccess: {
    margin: '15px',
    backgroundColor: '#EBF6EB',
    color: '#008908',
    fontSize: '6rem',
    '& .MuiSvgIcon-root': {
      fontSize: '6rem',
    },
  },
  iconeSVG: {
    width: '50px',
    height: '50px',
  },
}))
